// @flow
import React, { Component } from 'react';

import Type from '../Type';
import Description from '../Description';
import type { Parameter } from '../../reducers/version';

type Props = Parameter & {
  version: string;
};

class ParameterItem extends Component<void, Props, void> {
  render() {
    const {
      props: {
        name,
        type,
        version,
        description
      }
    } = this;

    return (
      <li>
        <div className="mb2">
          {name}: <Type name={type} version={version} />
        </div>
        <Description className="mb3 ml3" content={description} />
      </li>
    );
  }
}

export default ParameterItem;



// WEBPACK FOOTER //
// ./src/components/ParameterItem/index.jsx